<template>
  <el-dialog
          title="流水概览详情"
          :visible.sync="dialogVisible"
          @opened="dialogOpen"
          customClass="customWidth"
  >
    <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            size="mini"
            style="margin-bottom: -18px;"
    >

      <el-form-item
      >
        <el-date-picker
                v-model="pickerValue"
                type="daterange"
                align="right"
                size="small"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd" format="yyyy-MM-dd">
          ></el-date-picker>
      </el-form-item>

      <el-form-item
      >
        <el-select
                class="filter-item"
                v-model="searchForm.pay_type"
                placeholder="支付方式"
        >
          <el-option
                  v-for="item in bsOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
                type="primary"
                @click="handleSearchFormSubmit"
        >
          <d2-icon name="search" /> 查询
        </el-button>
      </el-form-item>

      <el-form-item>
        <el-button @click="handleSearchFormReset">
          <d2-icon name="refresh" /> 重置
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
            :data="tableData"
            v-loading="loading"
            :span-method="objectSpanMethod"
            size="small"
            stripe
            highlight-current-row
            style="width: 100%;"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
    >


      <el-table-column
              label="日期"
      >
        <template slot-scope="scope">
          {{scope.row.order_time}}
        </template>
      </el-table-column>

      <el-table-column
              label="支付方式"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.pay_type=='微信刷脸'">
            微信
          </div>
          <div v-else-if="scope.row.pay_type=='支付宝刷脸'">
            支付宝
          </div>
          <div v-else-if="scope.row.pay_type=='银行卡'">
            银行卡
          </div>
          <div v-else-if="scope.row.pay_type=='会员卡'">
            会员卡
          </div>
          <div v-else-if="scope.row.pay_type=='退款'">
            退款
          </div>

        </template>
      </el-table-column>
      <el-table-column
              label="支付通道"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          官方
        </template>
      </el-table-column>
      <el-table-column
              label="订单金额"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.order_amount}}
        </template>
      </el-table-column>
      <el-table-column
              label="订单数量"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.order_num}}
        </template>
      </el-table-column>
      <el-table-column
              label="退款金额"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.refund_amount}}
        </template>
      </el-table-column>
      <el-table-column
              label="退款数量"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.refund_num}}
        </template>
      </el-table-column>
      <el-table-column
              label="有效交易基数"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.yx_order_amount}}
        </template>
      </el-table-column>
      <el-table-column
              label="顾客实付"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.payment_amount}}
        </template>
      </el-table-column>



    </el-table>
    <div style="text-align: center;margin-top: 30px;">
      <el-pagination
              :current-page="page.current"
              :page-size="page.size"
              :total="page.total"
              :page-sizes="[1,10,50,100, 200, 300, 400]"
              layout="total, sizes, prev, pager, next, jumper"
              style="margin: -10px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

  </el-dialog>

</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
    export default {
        name: "threeagentEditForm",
        props: {
            agentid: String,
            pickerValue2: String,
            pickerValue3: String,
            value: Boolean
        },
        data() {
            return {
                loading: false,
                pos:0,
                dialogVisible: false,
                tableData: [],
                pickerValue: [],
                supplierNamearr1:[],
                bsOptions: [
                    {
                        value: "支付宝刷脸",
                        label: "支付宝"
                    },
                    {
                        value: "微信刷脸",
                        label: "微信"
                    },
                    {
                        value: "银行卡",
                        label: "银行卡"
                    },
                    {
                        value: "会员卡",
                        label: "会员卡"
                    }
                ],
                searchForm: {

                },
                page: {
                    current: 1,
                    size: 10,
                    total: 0
                },
                sort: {
                    prop: "",
                    order: ""
                }
            };
        },
        watch: {
            value(val) {
                this.dialogVisible = val;
            },
            dialogVisible(val) {
                this.$emit("input", val);
            }
        },
        methods: {
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {                     //合并第一列
                    let _row = this.supplierNamearr1[rowIndex];
                    let _col = _row> 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    };

                }

            },
            supplierNamesetdates(arr) {
                // console.log(arr)
                var obj = {},
                    k, arr1 = [];
                for(var i = 0, len = arr.length; i < len; i++) {
                    k = arr[i].order_time;
                    if(obj[k])
                        obj[k]++;
                    else
                        obj[k] = 1;
                }
                // console.log(obj);
                //保存结果{el-'元素'，count-出现次数}
                for(var o in obj) {
                    for(let i=0;i<obj[o];i++){
                        if(i===0){
                            this.supplierNamearr1.push(obj[o])
                        }else{
                            this.supplierNamearr1.push(0)
                        }
                    }
                }
                // console.log("arr1",this.supplierNamearr1);
            },
            dateConversion(value){
                var d = new Date(value);
                //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
                var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
                console.info("===========date========="+date);
                return date;
            },
            dialogOpen() {
                this.$refs.searchForm.resetFields();
                this.pickerValue=[this.pickerValue2,this.pickerValue3];
                this.getTableData33();

            },
            getTableData33() {

                console.info("===========ddddddddd========="+this.pickerValue[0]);
                let query = {
                    pageIndex: this.page.current,
                    pageSize: this.page.size,
                    sortBy: this.sort.prop,
                    agentid: this.agentid,
                    start_time:this.pickerValue[0],
                    end_time:this.pickerValue[1],
                  dl_type:util.cookies.get('dl_type'),
                  user_agentid:util.cookies.get('agentid'),
                    descending: this.sort.order === "descending",
                    filter: this.searchForm
                };
                agentService.getMobileOrderPagedlistXq(query).then(data => {
                    this.tableData = data.rows;
                    this.page.total = data.totalCount;
                    this.supplierNamesetdates(data.rows);
                });
            },
            handleSearchFormSubmit() {
                this.getTableData33();
            },
            handleSearchFormReset() {
                this.$refs.searchForm.resetFields();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleSortChange(val) {
                this.sort.prop = val.prop;
                this.sort.order = val.order;
                this.getTableData33();
            },
            handleSizeChange(val) {
                this.page.size = val;
                this.getTableData33();
            },
            handleCurrentChange(val) {
                this.page.current = val;
                this.getTableData33();
            },
            close() {
                this.$refs["searchForm"].resetFields();
                this.dialogVisible = false;
            }
        }
    };
</script>
<style>
  .customWidth{
    width:80%;
  }
</style>
